import React from "react"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { createRoot } from "react-dom/client"
import AdPlayerTotem from "../AdPlayerTotem"
import UserContext from "../../UserContext"

const MySwal = withReactContent(Swal)

const AD_TYPE_LABELS = {
  1: { label: "Vidéo", badgeClass: "badge-info" },
  2: { label: "Image", badgeClass: "badge-success" },
  3: { label: "PDF", badgeClass: "badge-warning" },
}

function ResourcePreviewContent({ ad }) {
  const typeInfo = AD_TYPE_LABELS[ad.adTypeId] || { label: "Inconnu", badgeClass: "badge-secondary" }

  return (
    <div className="text-center">
      <h5 className="mb-2">{ad.name}</h5>
      <div className="mb-3">
        <span className={`badge ${typeInfo.badgeClass} mr-2`}>{typeInfo.label}</span>
        <span className="text-muted">
          <i className="fas fa-expand-arrows-alt mr-1"></i>
          {ad.width}x{ad.height}
        </span>
      </div>
      <div style={{ overflowX: "auto", maxWidth: "100%" }}>
        <AdPlayerTotem ad={ad} showDownload={false} />
      </div>
    </div>
  )
}

export const openResourcePreviewModal = (ad, userContext) => {
  let reactRoot = null

  MySwal.fire({
    html: "<div id='react-resource-preview-container'></div>",
    showConfirmButton: false,
    showCloseButton: true,
    width: "auto",
    didOpen: () => {
      document.activeElement?.blur()
    },
    willOpen: (popup) => {
      document.documentElement.style.overflowX = "hidden"
      popup.style.maxWidth = "calc(100vw - 2rem)"
      popup.style.boxSizing = "border-box"
      popup.style.overflowX = "hidden"

      const container = document.getElementById("react-resource-preview-container")

      if (container) {
        reactRoot = createRoot(container)
        reactRoot.render(
          <UserContext.Provider value={userContext}>
            <ResourcePreviewContent ad={ad} />
          </UserContext.Provider>
        )
      }
    },
    didClose: () => {
      document.documentElement.style.overflowX = ""
      if (reactRoot) {
        reactRoot.unmount()
        reactRoot = null
      }
    },
  })
}
